import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, Process, Pricing, ProjectSection, Partners, Calculator, Mission, PortfolioSection, GetQuote } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <About /> {/* About Section */}
      <Services /> {/* Services Slider */}
      <Counter /> {/* Counter Section */}
      <Mission /> {/* Mission section */}
      <Banner /> {/* Banner Section */}
      <PortfolioSection /> {/* Projects Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <GetQuote /> {/* Calculator section */}
      <Pricing /> {/* Pricing section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;